module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/madh0-f66c9ed90e26e1054353d2e226475c1a.jpg";